export default {
  system: {
    notAvailable: {
      en: "System is not available.",
      pt: "Sistema fora do ar.",
    },
    labelButton: {
      available: {
        en: "Available",
        pt: "Ativo",
      },
      disabled: {
        en: "Disabled",
        pt: "Inativo",
      },
    },
    version: {
      en: "Version: ",
      pt: "Versão: ",
    },
  },
};
